export default {"src":"/_next/static/media/WhoWeAre_023A.3d6d10b8.JPG","height":686,"width":1920};